import React, { Component } from 'react';
import _ from 'lodash';

import { channelStatusOptions } from '../../../../utils/options';
import FilterGroup from '../../../../components/FilterGroup/FilterGroup';
import ChannelList from './components/ChannelList/ChannelList';

const API_URL = process.env.API_URL;

export class ChannelPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            channelSources: [],
            channelTypes: [],
            filters: {},
            searchText: ''
        }
    }

    fetchChannelSource() {
        const jwt = localStorage.getItem('jwt');

        return fetch(`${API_URL}/channel-source`, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${jwt}`
                }
            })
            .then((res) => res.json())
            .then((json) => this.setState({ channelSources: json }))
    }

    fetchChannelType() {
        const jwt = localStorage.getItem('jwt');

        return fetch(`${API_URL}/channel-type`, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${jwt}`
                }
            })
            .then((res) => res.json())
            .then((json) => this.setState({ channelTypes: json }))
    }

    componentDidMount() {
        this.fetchChannelSource();
        this.fetchChannelType();
    }

    render() {
        const { channelSources, channelTypes, filters, searchText } = this.state;
        const filterList = [{
            type: 'select',
            name: 'type',
            placeholder: 'Type',
            options: _.map(channelTypes, (channelType) => ({ label: channelType.name, value: channelType.name }))
        }, {
            type: 'select',
            name: 'source',
            placeholder: 'Source',
            options: _.map(channelSources, (channelSource) => ({ label: channelSource.name, value: channelSource.name }))
        }, {
            type: 'select',
            name: 'status',
            placeholder: 'Status',
            options: _.map(channelStatusOptions, (channelStatus) => ({ label: channelStatus, value: channelStatus }))
        }];

        return (
            <div className="ChannelPage ListPage">
                <div className="page-header">
                    <h2>Channel</h2>
                    <FilterGroup
                        filterList={filterList}
                        onChange={(filters, searchText) => this.setState({ filters, searchText })}
                    />
                </div>
                <ChannelList
                    filters={filters}
                    searchText={searchText}
                />
            </div>
        );
    }
}

export default ChannelPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ChannelPage/ChannelPage.js